import { course } from './course';

export const courseList: course[] = [
  {
    Id: 1,
    courseType: 'primary',
    courseFramework: 'Web',
    Time: '30 min',
    courseName: 'Html Crash Course',
    Update: 'Updated 21 Jan 2024',
  },
  {
    Id: 2,
    courseType: 'error',
    courseFramework: 'Angular',
    Time: '90 min',
    courseName: 'Angular Course',
    Update: 'Updated 25 Jan 2024',
  },
  {
    Id: 3,
    courseType: 'warning',
    courseFramework: 'Android',
    Time: '30 min',
    courseName: 'Android Crash Course',
    Update: 'Updated 30 Jan 2024',
  },
  {
    Id: 4,
    courseType: 'secondary',
    courseFramework: 'Design',
    Time: '50 min',
    courseName: 'Web Designing Course',
    Update: 'Updated 01 Feb 2024',
  },
  {
    Id: 5,
    courseType: 'primary',
    courseFramework: 'Web',
    Time: '120 min',
    courseName: 'Basics of TypeScript',
    Update: 'Updated 15 Feb 2024',
  },
  {
    Id: 6,
    courseType: 'warning',
    courseFramework: 'Android',
    Time: '60 min',
    courseName: 'Android N: Quick Settings',
    Update: 'Updated 16 Feb 2024',
  },
  {
    Id: 7,
    courseType: 'primary',
    courseFramework: 'Web',
    Time: '90 min',
    courseName: 'First Progressive Web App',
    Update: 'Updated 18 Feb 2024',
  },
  {
    Id: 8,
    courseType: 'error',
    courseFramework: 'Angular',
    Time: '150 min',
    courseName: 'Basics of Angular',
    Update: 'Updated 20 Feb 2024',
  },
  {
    Id: 9,
    courseType: 'secondary',
    courseFramework: 'Design',
    Time: '80 min',
    courseName: 'PSD to HTML From Scratch',
    Update: 'Updated 21 Feb 2024',
  },
];
